/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard (C) Copyright IBM Corp. 2020, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'react',
	'../../../lib/@waca/core-client/js/core-client/utils/UniqueId',
	'prop-types',
	'@ba/ba-ui-carbon-toolkit'
], function (React, UniqueId, PropTypes, UI_CARBON) {
	const ToggleSwitchCarbon = UI_CARBON.ToggleSwitch;

	class ToggleSwitch extends React.Component {

		constructor(props) {
			super(props);
			this.myRef = React.createRef();
			this.state = {
				checked: true
			};
		}

		_handleChange() {
			if (this.props.itemSpec.action) {
				this.props.itemSpec.action.apply();
			}
			this.setState({ checked: !this.state.checked });
		}

		_getButtonClass() {
			const classList = [];
			if (this.state.checked) {
				classList.push('checked');
			}
			if (this.props.itemSpec.className) {
				classList.push(this.props.itemSpec.className);
			}
			return classList.join(' ');
		}

		componentDidMount() {
			this.props.itemSpec.isChecked().then(value => {
				if (this.state.checked != value) {
					this.setState({ checked: value });
				}
			});
		}

		render() {
			const { id, label, small, title, ...others } = this.props.itemSpec;
			return (
				<ToggleSwitchCarbon
					id={`${id}_${UniqueId.get()}`}
					label={label}
					title={title}
					disabled={others.disabled}
					className={this._getButtonClass()}
					small={small}
					checked={this.state.checked}
					onChange={() => this._handleChange()}
				/>
			);
		}
	}

	ToggleSwitch.propTypes = {
		itemSpec: PropTypes.array
	};

	return ToggleSwitch;
});
